module.exports = __webpack_public_path__ + "img/unicorn.b1b91b70.jpg";